"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gameContext = void 0;
var react_1 = __importDefault(require("react"));
var MissingRules = /** @class */ (function () {
    function MissingRules() {
        throw new Error('Missing GameContext');
    }
    return MissingRules;
}());
// @ts-ignore
var missingContext = { game: '', Rules: MissingRules };
exports.gameContext = react_1.default.createContext(missingContext);
if (process.env.NODE_ENV !== 'production') {
    exports.gameContext.displayName = 'GameContext';
}
